/**
 * @module servicesSearchFacetsV2
 */

function isServiceSearchPage() {
    return !!document.querySelector(".servicefinder-search");
}

const servicesSearchFacetsV2 = {
    init() {
        this.observeFacets();
    },

    /* ---------------------------------
    Apply filters
    --------------------------------- */
    applyFilters(filters) {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        const query = params.get("query");

        params.forEach((_, key) => {
            if (key !== "query") params.delete(key);
        });

        filters.forEach(({ key, value }) => {
            if (key && value) params.append(key, decodeURIComponent(value));
        });

        if (query) params.set("query", query);

        window.location.search = params
            .toString()
            .replace(/%2B/g, "+")
            .replace(/\+_/g, "%2B_")
            .replace(/%257C/g, "%7C");
    },

    /* ---------------------------------
    Get filters
    --------------------------------- */
    getFilters(container) {
        return [...container.querySelectorAll(".qld__search__facet-input")]
            .filter((i) => i.checked)
            .map((input) => {
                const [key, value] = input.dataset.querystring.split("=");
                return { key, value };
            });
    },

    /* ---------------------------------
    Restore filters
    --------------------------------- */
    restoreFilters() {
        const params = new URLSearchParams(window.location.search);

        document
            .querySelectorAll(".qld__search__facet-input")
            .forEach((input) => {
                const [key, value] = input.dataset.querystring.split("=");

                const values = params.getAll(decodeURIComponent(key));

                input.checked = values.includes(decodeURIComponent(value));
            });

        const query = params.get("query");
        const queryInfo = document.querySelector(".qld__search__info-query");

        if (query && queryInfo) {
            queryInfo.style.display = "block";
            queryInfo.querySelector(
                ".qld__search__info-query-term",
            ).textContent = `'${query}'`;

            const input = document.getElementById(
                "search-input-resources-query",
            );
            if (input) input.value = query;
        }
    },

    /* ---------------------------------
    Observe facets
    --------------------------------- */
    observeFacets() {
        const observer = new MutationObserver((_, obs) => {
            const facets = document.querySelector(".qld__search__facets");
            if (!facets) return;

            obs.disconnect();

            this.initCategories();
            this.initBehaviour(facets);
            this.restoreFilters();
            this.removeEmptyFacets();
            if (window.QLD?.accordion?.init) {
                QLD.accordion.init();
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        setTimeout(() => observer.disconnect(), 10000);
    },

    /* ---------------------------------
    Remove empty facets
    --------------------------------- */
    removeEmptyFacets() {
        document.querySelectorAll(".qld__search__facet").forEach((facet) => {
            const list = facet.querySelector(".qld__search__facet-list");
            if (!list || !list.querySelector("li")) facet.remove();
        });
    },

    /* ---------------------------------
    Fetch service categories
    --------------------------------- */
    initCategories() {
        const url =
            "https://au-e375edfd.datastore.squiz.cloud/service-categories";

        fetch(url)
            .then((r) => r.json())
            .then((cats) => {
                document
                    .querySelectorAll(".qld__search__facet-label--text")
                    .forEach((el) => {
                        const match = cats.find((c) => c.id === el.textContent);
                        if (match) el.textContent = match.name;
                    });
            })
            .catch((e) => {
                // eslint-disable-next-line no-console
                console.error("Error fetching service categories", e);
            });
    },

    /* ---------------------------------
    Behaviour
    --------------------------------- */
    initBehaviour(facetsComponent) {
        const BREAKPOINT = 991;
        const facetLists = [
            ...facetsComponent.querySelectorAll(".qld__search__facet-list"),
        ];
        const applyBtn = document.querySelector(".qld__apply-filters__btn");
        const clearBtns = document.querySelectorAll(".qld__btn--tertiary");
        const facetsButton = facetsComponent.querySelector(
            ".qld__search__facets__toggle",
        );
        const facetsBody = document.getElementById("search__facets");

        if (!facetLists.length) return;

        const params = new URLSearchParams(window.location.search);
        const query = params.get("query");

        let isMobile = window.innerWidth <= BREAKPOINT;

        initInputs();
        initApply();
        initClear();
        initFacetListToggle();

        isMobile ? setMobileView() : setDesktopView();
        window.addEventListener("resize", debounce(resizeCheck, 120));

        /* ---------- functions ---------- */

        function initInputs() {
            document
                .querySelectorAll(".qld__search__facet-input")
                .forEach((input) => {
                    input.addEventListener("keydown", (e) => {
                        if (e.key === "Enter") {
                            input.checked = !input.checked;
                            input.dispatchEvent(new Event("change"));
                        }
                    });
                });
        }

        function initApply() {
            if (!applyBtn) return;

            applyBtn.addEventListener("click", (e) => {
                e.preventDefault();

                const filters = facetLists.flatMap((list) =>
                    servicesSearchFacetsV2.getFilters(list),
                );

                servicesSearchFacetsV2.applyFilters(filters);
            });
        }

        function initClear() {
            clearBtns.forEach((btn) => {
                btn.addEventListener("click", () => {
                    window.location.href =
                        window.location.pathname +
                        (query ? `?query=${query}` : "");
                });
            });
        }

        function initFacetListToggle() {
            document
                .querySelectorAll(".qld__search__facet-button--toggle")
                .forEach((btn) => {
                    const list = btn.closest(".qld__search__facet-list");
                    const items = [...list.querySelectorAll("li")];

                    if (items.length <= 8) {
                        btn.classList.add("hidden");
                        return;
                    }

                    items.slice(8).forEach((li) => li.classList.add("hidden"));

                    btn.addEventListener("click", () => {
                        const showAll = btn.classList.toggle("showing-all");

                        items
                            .slice(8)
                            .forEach((li) =>
                                li.classList.toggle("hidden", !showAll),
                            );

                        btn.textContent = showAll ? "Show less" : "Show all";
                    });
                });
        }

        function resizeCheck() {
            const mobile = window.innerWidth <= BREAKPOINT;

            if (mobile !== isMobile) {
                isMobile = mobile;
                mobile ? setMobileView() : setDesktopView();
            }
        }

        function setMobileView() {
            facetsComponent.classList.add("qld__accordion");

            if (facetsButton) facetsButton.style.display = "block";

            if (window.QLD?.initAll) window.QLD.initAll();
        }

        function setDesktopView() {
            facetsComponent.classList.remove("qld__accordion");

            if (facetsButton) facetsButton.style.display = "none";

            if (facetsBody) {
                facetsBody.classList.add("qld__accordion--open");
                facetsBody.classList.remove("qld__accordion--closed");
            }
        }

        function debounce(fn, wait) {
            let t;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn(...args), wait);
            };
        }
    },
};

export default servicesSearchFacetsV2;

document.addEventListener("DOMContentLoaded", () => {
    if (isServiceSearchPage()) {
        servicesSearchFacetsV2.init();
    }
});
